import { format, parseISO } from "date-fns";

/**
 * Parse form/API date strings without shifting the calendar day.
 * `YYYY-MM-DD` is local midnight; other strings use native `Date` parsing (e.g. full ISO instants).
 */
export function parseLocalDateInput(
  input: string | Date | null | undefined
): Date {
  if (input == null) return new Date(NaN);
  if (input instanceof Date) return input;
  const s = String(input).trim();
  if (!s) return new Date(NaN);
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return parseISO(s);
  return new Date(s);
}

/**
 * Formats a date string or Date to "dd - LLL - yyyy" (e.g., "12 - Dec - 2025").
 * Returns "-" if the input is falsy or invalid.
 */
export const formatDisplayDate = (
  dateInput?: string | Date | null | undefined
): string => {
  if (!dateInput) return "-";
  const date =
    typeof dateInput === "string" ? parseLocalDateInput(dateInput) : dateInput;
  if (Number.isNaN(date?.getTime?.())) return "-";
  try {
    return format(date as Date, "dd - LLL - yyyy");
  } catch (e) {
    return "-";
  }
};

